/**
 * A list of certificates, each with its date, its verify code and a download.
 *
 * One component for both places that show them: a learner's own on My
 * learning (`showLearner` off — they are all theirs) and a course's on its
 * report (`showLearner` on). The download is a plain link: the PDF route reads
 * the session cookie like any other GET, and the browser saves the file.
 */

import type { CertificateWire } from '@wire';
import { learn } from '../api';
import { HAIR, monoPlain } from '../theme';

const dated = (at: number): string =>
  new Date(at * 1000).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });

export function CertificateList({
  certificates,
  showLearner
}: {
  certificates: CertificateWire[];
  showLearner: boolean;
}) {
  return (
    <div style={{ display: 'grid' }}>
      {certificates.map((c, i) => (
        <div
          key={c.id}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            flexWrap: 'wrap',
            padding: '10px 0',
            borderTop: i === 0 ? 'none' : HAIR
          }}
        >
          <div style={{ display: 'grid', gap: 2, flex: '1 1 220px', minWidth: 0 }}>
            <span style={{ fontSize: 13.5, overflowWrap: 'anywhere' }}>
              {showLearner ? (c.learner?.name ?? '—') : c.courseTitle}
            </span>
            <span style={monoPlain}>{`${dated(c.completedAt)} · ${c.code}`}</span>
          </div>
          <a
            href={c.verifyUrl}
            target="_blank"
            rel="noreferrer"
            style={{ ...monoPlain, color: 'var(--text-muted)' }}
          >
            Verify
          </a>
          <a href={learn.certificatePdfUrl(c.id)} download style={{ fontSize: 13, fontWeight: 600 }}>
            Download
          </a>
        </div>
      ))}
    </div>
  );
}
